import * as _4 from 'lodash4';

angular.module('biz-ng-requisite-tree').directive('addAttr', [
  '$timeout',
  '$parse',
  ($timeout: ng.ITimeoutService, $parse: ng.IParseService) => ({
    restrict: 'A',
    link: ($scope: ng.IScope, $elem: ng.IAugmentedJQuery, $attrs: ng.IAttributes) => {
      const notParsedConfig = $attrs['addAttr'];
      if (_4.isEmpty(notParsedConfig)) {
        return;
      }

      const parsedConfig = $parse(notParsedConfig)({});
      const attributeToAdd = parsedConfig['attribute'] || '';
      const timeout = _4.toNumber(parsedConfig['timeout']) || 0;

      $timeout(() => {
        $elem.attr(attributeToAdd, '');
      }, timeout);
    }
  })
]);



// WEBPACK FOOTER //
// ./app/vendor/biz-ng-requisite-tree/src/directives/add_attr.ts